// src/modules/forge/api/index.ts

import axios from "axios";
import { axiosPrivate } from "@/modules/common/api";

export async function getForgeToken() {
  const response = await axiosPrivate.get("/api/v1/forge/oauth/token");
  return response.data;
}

export async function listBuckets() {
  const response = await axiosPrivate.get("/api/v1/forge/buckets");
  return response.data;
}

export async function listObjects(bucketKey: string, limit = 100) {
  const response = await axiosPrivate.get(`/api/v1/forge/buckets/${bucketKey}/objects`, {
    params: { limit },
  });
  return response.data;
}

export async function translateModel(objectId: string) {
  const response = await axiosPrivate.post("/api/v1/forge/translate", { object_id: objectId });
  return response.data;
}

export async function checkTranslationStatus(objectUrn: string) {
  // objectUrn = "urn:..."
  // например "urn:dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6YnVja2V0S2V5L29iamVjdEtleS5ydnQ="
  const res = await axiosPrivate.get("/api/v1/forge/translate/status", {
    params: {
      object_id: objectUrn,
    },
  });
  return res.data;
}

export async function uploadFileViaS3(bucketName: string, file: File) {
  const formData = new FormData();
  formData.append("bucket_name", bucketName);
  formData.append("file", file);

  const response = await axiosPrivate.post("/api/v1/forge/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function fetchDbProperties(forgeModelId: string, forgeElementId: number) {
  // GET /properties?forge_model_id=xxx&forge_element_id=yyy
  const response = await axiosPrivate.get("/api/v1/forge/properties", {
    params: { forge_model_id: forgeModelId, forge_element_id: forgeElementId },
  });
  return response.data; // { forge_model_id, forge_object_id, properties: {...} }
}

export async function updateDbProperties(
  forgeModelId: string,
  forgeElementId: number,
  properties: Record<string, any>,
) {
  // PUT /properties?forge_model_id=xxx&forge_element_id=yyy
  const response = await axiosPrivate.put(
    "/api/v1/forge/properties",
    {
      properties, // тело запроса { properties: {...} }
    },
    {
      params: { forge_model_id: forgeModelId, forge_element_id: forgeElementId },
    },
  );
  return response.data; // { forge_model_id, forge_element_id, properties: {...} }
}

export async function fetchModuleSelections(forgeModelId: string) {
  const resp = await axiosPrivate.get("/api/v1/forge/modules/selections", {
    params: { forge_model_id: forgeModelId },
  });
  return resp.data;
}

export async function saveModuleSelections(payload: {
  forge_model_id: string;
  changes: Array<{
    element_db_id: number;
    module_number: string;
    work_type: string;
    checked: boolean;
  }>;
}) {
  const resp = await axiosPrivate.post("/api/v1/forge/modules/selections", payload);
  return resp.data;
}
